import React from 'react';
const CLIENT_LOGOS = [{
  name: 'Level Up Insurance',
  url: 'https://cdn.magicpatterns.com/uploads/erck2w6WcpUUyVmzLAoCk7/Logo-Level-Up-Insurance.png'
}, {
  name: 'Omnicredit',
  url: 'https://cdn.magicpatterns.com/uploads/tBb95ZdK8szGAN2Y4h7js4/Logo-Omnicredit.png'
}, {
  name: 'The Christmas Palace',
  url: 'https://cdn.magicpatterns.com/uploads/9ruFxsdEp6eBqKjyX7FuCX/Logo-The-Christmas-Palace.png'
}, {
  name: 'Xclusive Agent Leads',
  url: 'https://cdn.magicpatterns.com/uploads/7V7ea8q5iEoTSW2z4TESWb/Logo-Xclusive-Agent-Leads.png'
}, {
  name: 'Z Roofing',
  url: 'https://cdn.magicpatterns.com/uploads/jc2Eyw7WQ5GQ9kV6UKhZg8/Z-Roofing.png'
}];
export function ClientTicker() {
  return;
}